<template>
  <div class="chat-msg-container">
    <div v-if="loading" style="text-align: center;padding-top: 150px;">
      <loading></loading>
    </div>
    <ul class="chat-msg-list" id="chat-msg-list">
      <li class="clearfix" v-for="msg in nim.msgs" :class="msg.flow">
        <img v-if="msg.flow === 'out' && nim.user.avatar" class="avatar" :src="nim.user.avatar.indexOf('http://pic.joyorders.com')>-1?nim.user.avatar:'http://pic.joyorders.com' + nim.user.avatar"/>
        <img v-if="msg.flow === 'out' && !nim.user.avatar" src="../../assets/images/avatar@2x.png" />
        <img v-if="msg.flow === 'in' && session.user.avatar" class="avatar" :src="session.user.avatar.indexOf('http://pic.joyorders.com')>-1?session.user.avatar:'http://pic.joyorders.com' + session.user.avatar"/>
        <img v-if="msg.flow === 'in' && !session.user.avatar" src="../../assets/images/avatar@2x.png" />
        <div>
          <div class="msg-content">
            <i class="el-icon-caret-left" v-if="msg.flow === 'in'"></i>
            <i class="el-icon-caret-right" v-else></i>
            <i class="el-icon-arrow-right" v-if="msg.flow === 'out'"></i>
            <span v-if="msg.type == 'text'" v-html="msg.text"></span>
            <span v-if="msg.type == 'image'">
              <a target="_blank" :href="msg.file.url">
                <img class="file-image" :src="msg.file.url" />
              </a>
            </span>
            <span v-if="msg.type == 'file'">
              文件：
              <a target="_blank" :href="API_HOST + '/api/passport.php?api=download_im_file&file_url=' + encodeURIComponent(msg.file.url) + '&file_name=' + encodeURIComponent(msg.file.name)">
                {{msg.file.name}}
              </a>
            </span>
          </div>
          <p class="time" v-if="msg.nextMsg.time - msg.time > 180000">{{msg.time | moment('HH:mm')}}</p>
        </div>
      </li>
    </ul>
    <div class="dialog-container clearfix">
      <textarea maxlength="1024" placeholder="发送消息…" @keyup.enter="sendMsg" v-model="text"></textarea>
      <ChatEmoji v-on:add-emoji="addEmoji" v-if="isShowEmoji"></ChatEmoji>
      <div class="oprations">
        <i @click="isShowEmoji = !isShowEmoji" class="ico ico-emoji"></i>
        <ChatFile :toAccountId="toAccid" v-if="!text"><i class="ico ico-attachment"></i></ChatFile>
        <i v-else class="ico ico-send" @click="sendMsg()"></i>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '../../components/Loading'
import ChatEmoji from './ChatEmoji'
import ChatFile from './ChatFile'
import {API_HOST} from '../../services/constant.js'

export default {
  name: 'Chat',
  props: ['toAccountId', 'session'],
  components: {
    loading,
    ChatEmoji: ChatEmoji,
    ChatFile: ChatFile
  },
  computed: {
    nim () {
      return this.$store.state.nim
    }
  },
  data () {
    return {
      API_HOST: API_HOST,
      text: null,
      loading: true,
      isShowEmoji: false
    }
  },
  created () {
    if (this.session) {
      this.toAccid = this.session.to
    } else {
      this.toAccid = `${window.env}-user-${this.toAccountId}`
      this.session = {}
      this.getUser()
    }
    this.nim.msgs = []
    this.sessionId = `p2p-${this.toAccid}`
    this.data = {}
    this.addFriend()
    this.getHistoryMsgs()
  },
  methods: {
    addEmoji (emoji) {
      this.text = this.text || ''
      this.text += emoji
      this.isShowEmoji = false
    },
    showChatDialog() {

      this.sendMsg()
      console.log('nim', this.nim, this.toAccid);
    },
    addFriend() {
      this.nim.addFriend({
        account: this.toAccid,
        ps: 'ps',
        done: () => {
          console.log('success')
        }
      });
    },
    sendMsg(msg) {
      if (!_.trim(this.text)) {
        return
      }
      var msg = this.nim.sendText({
        scene: 'p2p',
        to: this.toAccid,
        text: this.text,
        done: () => {
          console.log('send success')
        }
      })
      msg.user = this.session.user
      this.nim.pushMsg(msg)
      this.text = null
      this.$forceUpdate()
    },
    getHistoryMsgs () {
      this.nim.getHistoryMsgs({
        scene: 'p2p',
        to: this.toAccid,
        done: (error, obj) => {
            console.log('获取p2p历史消息' + (!error?'成功':'失败'));
            console.log(error);
            console.log(obj);
            if (!error) {
              console.log('获取p2p历史消息', obj.msgs);
              this.nim.resetSessionUnread(this.sessionId);
              console.log('this.session', this.session);
              this.session.unread = 0;
              this.nim.pushMsg(obj.msgs)
              this.loading = false
              this.$forceUpdate()
            }
        }
      })
    },
    getUser () {
      let accounts = []
      _.each(this.nim.sessions, session => {
        accounts.push(session.to)
      })

      this.nim.getUser({
          account: this.toAccid,
          done: (error, user) => {
            console.log(error);
            console.log(user);
            console.log('获取用户资料' + (!error?'成功':'失败'), user);
            if (!error) {
              this.session.user = user
              this.$emit('setSession', this.session)
            }
          }
      });
    }
  },
  beforeDestroy () {
    this.nim.resetSessionUnread(this.sessionId);
    this.session.unread = 0;
    if (this.nim.sessions) {
      for (let session of this.nim.sessions) {
        if (session.unread > 0) {
          this.nim.unread = true
          return
        }
      }
    }
    this.nim.unread = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .chat-msg-container {
    position: relative;
    height: 100%;
    overflow: hidden;
  }
  .chat-msg-list {
    height: 448px;
    overflow: auto;
    li {
      padding: 15px;
    }

    .time {
        color: #B2B2B2;
        margin-top: 7px;
        font-size: 12px;
    }

    img {
      max-width: 40px;
    }

    .msg-content {
      padding: 10px;
      background-color: #F6F6F6;
      border-radius: 5px;
      position: relative;
      max-width: 260px;
      color: #000;
      word-break: break-all;

      span {
        font-size: 12px;
      }

      i {
        position: absolute;
        font-size: 20px;
        color: #F6F6F6;
        top: 8px;
      }
    }

    .file-image {
      max-width: 140px;
    }

    .in {
      & >* {
        float: left;
      }

      .msg-content {
        margin-left: 20px;
      }

      i {
        left: -13px;
      }

      .time {
        margin-left: 31px;
      }
    }

    .out {
      & > * {
        float: right;
      }

      .msg-content {
        margin-right: 20px;
        background-color: #fff;
        border: 1px solid #E5E5E5;

        i {
          color: #fff;
          right: -12px;
        }

        .el-icon-arrow-right {
          color: #E5E5E5;
          right: -13px;
        }
      }

      .time {
        margin-right: 31px;
        text-align: right;
        font-size: 12px;
      }
    }

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 100%;
    }
  }

  @media (max-width: 768px) {
    .chat-msg-list {
      height: calc(100vh - 183px);
    }
  }

  .dialog-container {
    border-top: 1px solid #ddd;
    padding: 15px 20px;
    width: 100%;
    background-color: #fff;

    position: absolute;
    bottom: 0;

    textarea {
      border: none;
      resize: none;
      height: 21px;
      font-size: 12px;
      width: 100%;
      display: block;
      padding-right: 70px;
    }

    .oprations {
      width: 80px;
      position: absolute;
      right: 0;
      top: 15px;

      .ico {
        margin-right: 15px;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/chat/ChatDetail.vue